/* @flow */
'use strict';

class NumberToLocalizedStringTransformer {
    reverseTransform(value: string, model: Object): string {
        return value.replace(',', '.').replace(/\s/g, '');
    }
}

window.SymfonyComponentFormExtensionCoreDataTransformerNumberToLocalizedStringTransformer = NumberToLocalizedStringTransformer;



// WEBPACK FOOTER //
// ./app/Resources/assets/js/lib/formTransformer/symfony.numberToLocalizedString.js